export const enum TaskTypeForCalendarShiftHoverEnum {
  LICENSING = 2,
  CREDENTIALS,
  FLIGHT,
  HOTEL,
  CAR
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/TaskTypeForCalendarShiftHoverEnum.ts